import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import CustomAvatar from "../Avatar/Avatar";
const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectCuenta
 * @description Select para las cuentas registrados en el sistema
 */
const SelectCuenta = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione el proyecto", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {} 
    } = props

    const [ cuentas, setCuentas ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getCuentas
     * @description Obitiene las cuentas
     */
    const getCuentas = ({page, limit, search} = cuentas) => {
        
        axios.get('/cuentas', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setCuentas(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener las cuentas')
        })
    }

    //componentDidMount
    useEffect(() => {
        getCuentas()
    }, [])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            getPopupContainer={(trigger) => trigger.parentNode}
            dropdownMatchSelectWidth={false}
            virtual={false}
            optionLabelProp="label"
            value={value || undefined}
            onSearch={(search) => getCuentas({ search })}
            onChange={(val) => { onChange?.(val); onSelect?.(val); }}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
                {(cuentas?.data || []).map(({ _id, nombre, color, logo }) => (
                    <Option value={_id} key={_id} label={nombre}>
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 3,
                                height: 32, 
                                lineHeight: '32px',
                            }}
                        >
                            <CustomAvatar
                                size="small"
                                image={logo ? `${axios.defaults.baseURL}/upload/${logo}` : undefined}
                                color={color}
                                name={nombre}
                            />
                            <span
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {nombre ?? ''}
                            </span>
                        </span>
                    </Option>
                ))}
        </Select>
    );
}

export default SelectCuenta;
